export default __webpack_public_path__ + "static/media/arrow-71445ee75b6b3202b559d169d7bcbff1.png";